<template>
  <div :id="'myOperate' + Math.random()">
    <div class="operation" style="padding-top: 10px">
      <div
        v-for="(item, index) in titleOperationTitleData"
        :key="index"
        class="operationItem"
      >
        <span
          v-if="item.type != 'button' && item.type != 'buttonList'"
          class="titleSpan"
          >{{ item.name }}</span
        >
        <div v-if="$scopedSlots[item.value]" style="display: inline-block">
          <slot :name="item.value" v-bind="titleData"></slot>
        </div>
        <el-input
          @keyup.enter.native="titleOperationBtnClick({ name: '搜索', type: 'button' })"
          size="small"
          v-else-if="item.type == 'text'"
          style="width: 210px"
          v-model="titleData[item.value]"
          :placeholder="'请输入' + item.name"
          clearable
        ></el-input>
        <!-- seclect 字典选择 -->
        <el-select
          size="small"
          v-else-if="item.type == 'select'"
          v-model="titleData[item.value]"
          clearable
          style="width: 200px"
          placeholder="请选择"
        >
          <el-option
            v-for="dict in selectData(item.selectOptionKey)"
            :key="dict.itemId"
            :label="dict.name"
            :value="dict.itemId"
          ></el-option>
        </el-select>
        <!-- customSelect 字典选择 -->
        <el-select
          size="small"
          v-else-if="item.type == 'customSelect'"
          v-model="titleData[item.value]"
          placeholder="请选择"
          style="width: 200px"
          clearable
        >
          <el-option
            v-for="dict in item.selectOptionList"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          ></el-option>
        </el-select>
        <!-- 日期 -->
        <el-date-picker
          size="small"
          style="width: 310px"
          v-else-if="item.type == 'date'"
          v-model="titleData[item.value]"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <!-- 单日 -->
        <el-date-picker
          size="small"
          style="width: 210px"
          v-else-if="item.type == 'dateSingle'"
          v-model="titleData[item.value]"
          type="date"
          :placeholder="'请选择' + item.name"
          clearable
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <!-- 日期时间 -->
        <el-date-picker
          size="small"
          v-else-if="item.type == 'dateTime'"
          v-model="titleData[item.value]"
          type="datetimerange"
          style="width: 310px"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-button
          size="small"
          type="primary"
          @click="titleOperationBtnClick(item)"
          v-else-if="item.type == 'button'"
          >{{ item.name }}</el-button
        >
        <!-- 按钮组 -->
        <span class="button-list-wrapper" v-else-if="item.type == 'buttonList'">
          <el-button
            v-for="(element, elementIndx) in item.btnList"
            :key="elementIndx"
            size="small"
            type="primary"
            :class="{
              'button-primary': titleData[item.value] == element.value,
              'button-disabled': titleData[item.value] != element.value,
            }"
            :disabled="titleData[item.value] == element.value"
            @click="titleOperationBtnClick(element, item)"
            >{{ element.name }}</el-button
          >
        </span>
        <div
          style="width: 2px; margin: -10px -2px; color: #dcdfe6"
          v-else-if="item.type == 'line'"
        >
          丨
        </div>
      </div>

      <!-- 数字区间 -->

      <slot name="content"></slot>
      <!-- <el-popover
        style="float: right"
        placement="left-start"
        width="220"
        trigger="click"
        v-if="flag"
      >
        <drag-sort
          :titleList="titleList"
          @onStart="onStart"
          @onEnd="onEnd"
          @isShowClick="isShowClick"
          @widthClick="widthClick"
          @resetClick="resetClick"
          ref="dragSort"
        ></drag-sort>
        <el-button
          size="small"
          icon="el-icon-s-operation"
          class="btnTwo"
          style="color: #1476c3; border-color: #1476c3"
          slot="reference"
          >列表配置</el-button
        >
      </el-popover> -->
      <!-- <el-button
        v-if="flag"
        size="small"
        icon="el-icon-s-operation"
        class="btnTwo"
        style="color: #1476c3; border-color: #1476c3; float: right"
        @click="menuClick()"
        >列表配置</el-button
      > -->
      <dialogDragSort
        v-if="flag"
        :titleList="titleList"
        :flag="flag"
        @onStart="onStart"
        @onEnd="onEnd"
        @isShowClick="isShowClick"
        @widthClick="widthClick"
        @resetClick="resetClick"
        ref="dragSort"
      ></dialogDragSort>
      <el-button
        size="small"
        style="float: right; margin-right: 10px;"
        class="btnTwo"
        icon="el-icon-search"
        v-if="operationTitleData && operationTitleData.length > 0"
        @click="operationState = !operationState"
      >
        <span v-if="!operationState">更多搜索</span>
        <span v-if="operationState">收起</span>
      </el-button>
      <div style="clear: both"></div>
    </div>
    <!-- 操作栏 -->
    <div
      v-if="operationTitleData && operationTitleData.length > 0 && operationState"
      class="grid padding-xs"
    >
      <div
        v-for="(item, index) in operationTitleData"
        class="padding-xs flex-center"
        :key="index"
      >
        <span v-if="item.type != 'button'" class="titleSpan">{{ item.name }}</span>
        <div v-if="$scopedSlots[item.value]" style="display: inline-block">
          <slot :name="item.value" v-bind="titleData"></slot>
        </div>
        <el-input
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'text'"
          style="width: 200px"
          v-model="titleData[item.value]"
          :placeholder="'请输入' + item.name"
          clearable
          @input="operationBtnClick(item)"
        ></el-input>
        <el-input
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'number'"
          type="number"
          style="width: 200px"
          v-model="titleData[item.value]"
          :placeholder="'请输入' + item.name"
          clearable
          @input="operationBtnClick(item)"
        ></el-input>
        <!-- seclect 字典选择 -->
        <el-select
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'select'"
          v-model="titleData[item.value]"
          style="width: 200px"
          clearable
          placeholder="请选择"
          @change="operationBtnClick(item)"
        >
          <el-option
            v-for="dict in selectData(item.selectOptionKey)"
            :key="dict.itemId"
            :label="dict.name"
            :value="dict.itemId"
          ></el-option>
        </el-select>
        <!-- customSelect 字典选择 -->
        <el-select
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'customSelect'"
          v-model="titleData[item.value]"
          style="width: 200px"
          placeholder="请选择"
          clearable
          @change="operationBtnClick(item)"
        >
          <el-option
            v-for="dict in item.selectOptionList"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          ></el-option>
        </el-select>
        <!-- 日期 -->
        <el-date-picker
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'date'"
          v-model="titleData[item.value]"
          type="daterange"
          style="width: 300px"
          range-separator="—"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          value-format="yyyy-MM-dd"
          @change="operationBtnClick(item)"
        >
        </el-date-picker>
        <!-- 单日 -->
        <el-date-picker
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'dateSingle'"
          v-model="titleData[item.value]"
          type="date"
          style="width: 200px"
          :placeholder="'请选择' + item.name"
          clearable
          value-format="yyyy-MM-dd"
          @change="operationBtnClick(item)"
        >
        </el-date-picker>
        <!-- 日期时间 -->
        <el-date-picker
          class="flex-sub"
          size="small"
          v-else-if="item.type == 'dateTime'"
          style="width: 300px"
          v-model="titleData[item.value]"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="operationBtnClick(item)"
        >
        </el-date-picker>
        <div class="flex-sub w-100" v-else-if="item.type == 'button'">
          <div class="flex-center over-hidden">
            <el-button type="primary" size="small" @click="operationBtnClick(item)">{{
              item.name
            }}</el-button>
          </div>
        </div>
        <!-- 数值区间选择 -->
        <div
          class="number-range-wrapper flex-sub"
          v-else-if="
            item.type == 'NumberRange' &&
            titleData[item.value] &&
            titleData[item.value].length == 2
          "
        >
          <el-input
            v-model="titleData[item.value][0]"
            size="small"
            style="width: calc(100px - 0.6em - 10px)"
            placeholder="起始值"
            @change="operationBtnClick(item)"
          ></el-input>
          <span class="range-separator">至</span>
          <el-input
            v-model="titleData[item.value][1]"
            size="small"
            style="width: calc(100px - 0.6em - 10px)"
            placeholder="结束值"
            @change="operationBtnClick(item)"
          ></el-input>
        </div>
      </div>
      <slot name="searcher"></slot>
      <div style="clear: both"></div>
    </div>
    <!-- <hr class="margin-bottom"/> -->
    <!-- 自定义菜单栏 -->
    <!-- <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      class="dialog"
      :title="'列表配置'"
      width="500px"
      top="10%"
      @close="dialogClose"
    >
      <div style="text-align: right; font-size: 30px; cursor: pointer">
        <span @click="dialogClose">×</span>
      </div>
      <dialogDragSort
        :titleList="titleList"
        @onStart="onStart"
        @onEnd="onEnd"
        @isShowClick="isShowClick"
        @widthClick="widthClick"
        @resetClick="resetClick"
        ref="dragSort"
      ></dialogDragSort>
    </el-dialog> -->
  </div>
</template>
<script>
import { readDictionarySelect } from "@/utils/myUtils";
import dragSort from "./dragSort.vue";
export default {
  components: { dragSort },
  name: "myOperate",
  props: {
    // table显示的标头集合
    titleList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // myHtml专用
    operationTitleData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // myHtml专用
    titleOperationTitleData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // HTML专用模糊查询
    titleData: {
      type: Object,
      default: () => ({}),
    },
    operationState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      flag: false,
      dialogState: {
        show1: false,
      },
      isShow: "",
    };
  },
  created() {
    this.getBtnList();
  },
  methods: {
    handleInputTo(val, data, item) {
      this.titleData[item.value] = data;
      this.operationBtnClick(item);
    },
    // ----------列表配置弹窗
    menuClick() {
      this.dialogState.show1 = true;
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
    // ------------------------------------------------------------------
    userOk(row, item) {
      this.titleData[item.value] = row.showName;
      this.operationBtnClick(item);
    },
    userClearData(item) {
      this.titleData[item.value] = null;
      this.operationBtnClick(item);
    },
    // 操作栏按钮点击事件
    operationBtnClick(row) {
      this.$emit("operationBtnClick", row, this.titleData);
    },
    //
    titleOperationBtnClick(row, item) {
      if (item) {
        this.titleData[item.value] = row.value;
      }
      this.$emit("titleOperationBtnClick", row, this.titleData);
    },
    // 获取下拉选择框数据
    selectData(selectOptionKey) {
      let list = readDictionarySelect(selectOptionKey);
      return list;
    },
    // 处理操作栏数据
    getBtnList() {
      try {
        this.operationTitleData.forEach((item) => {
          if (
            item.type == "select" &&
            item.selectOptionList &&
            item.selectOptionList.length <= 0
          ) {
            SysGlobalDictController.listAll(this, {
              dictCode: item.selectOptionKey,
            }).then((res) => {
              item.selectOptionList = res.fullResultList;
            });
          } else if (item.type == "NumberRange") {
            this.titleData[item.value] = ["", ""];
            this.titleData = JSON.parse(JSON.stringify(this.titleData));
          }
        });
      } catch (error) {}
    },
    // 拖拽是否数据加载完毕
    dragSortShow() {
      this.flag = true;
    },
    // 开始拖拽事件
    onStart(titleList) {
      this.$emit("onStart", titleList);
    },
    // 拖拽结束事件
    onEnd(titleList) {
      this.$emit("onEnd", titleList);
    },
    // 复选框事件
    isShowClick(titleList) {
      this.$emit("isShowClick", titleList);
    },
    // 固定方向事件
    widthClick(titleList) {
      this.$emit("widthClick", titleList);
    },
    // 重置
    resetClick(titleList) {
      this.$emit("resetClick", titleList);
    },
  },
};
</script>

<style scoped>
/* ::v-deep .el-dialog__header {
  display: none;
} */
::v-deep .el-dialog__body {
  padding-top: 10px;
}

/* 图片 */
.item_image {
  height: 50px;
  padding: 0px 1px;
}

.section ::v-deep .el-upload--picture-card {
  padding-top: 3px;
}

.section ::v-deep .el-upload-list__item-preview {
  display: none !important;
}

.section ::v-deep .el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 14px;
}

.section ::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 38px;
  height: 38px;
}

.section ::v-deep .el-upload--picture-card {
  width: 38px;
  height: 38px;
  line-height: 38px;
  vertical-align: middle;
}

.btnOne {
  background: #1476c3;
  color: white;
  margin-right: 20px;
}

.spanBtn {
  color: #1476c3;
  font-size: 14px;
  cursor: pointer;
  width: 96px;
  text-align: center;
  line-height: 30px;
  float: left;
}

/*选中样式*/
.chosen {
  border: solid 1px #3089dc !important;
}

.avatar {
  height: 50px;
}

.operationItem {
  float: left;
  margin: 0px 5px 0px 5px;
  padding-bottom: 10px;
}

.titleSpan {
  font-size: 12px;
  font-weight: 600;
  margin-right: 10px;
}

.operation {
  /* margin-bottom: 20px; */
  /* padding-top: 10px; */
}

/* 那啥，没用的，删了出问题不负责 */
.section {
  height: 50px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -moz-user-select: none;
  /* Firefox私有属性 */
  -webkit-user-select: none;
  /* WebKit内核私有属性 */
  -ms-user-select: none;
  /* IE私有属性(IE10及以后) */
  -khtml-user-select: none;
  /* KHTML内核私有属性 */
  -o-user-select: none;
  /* Opera私有属性 */
  user-select: none;
  /* CSS3属性 */
}

.itemFixed-nav {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.itemFixed-nav-content {
  display: flex;
}

/* 数字选择器 */
.number-range-wrapper {
  display: flex;
  align-items: center;
}

.range-separator {
  margin: 0 10px;
}

.button-list-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  vertical-align: middle;
}

.button-list-wrapper ::v-deep .el-button + .el-button {
  margin-left: 0;
}

.button-primary {
  background-color: #1476c3;
  /* 蓝色 */
  border-color: #1476c3;
}

.button-primary:hover {
  background-color: #1476c3;
  /* 蓝色 */
}

.button-disabled {
  background-color: #f8f8f8;
  /* 灰色 */
  border-color: #efefef;
  color: #333;
}

.button-disabled:hover {
  background-color: #1476c3;
  /* 蓝色 */
  border-color: #1476c3;
  color: #fff;
}
</style>
